<!-- Notification header -->
<div class="sliding-notification-panel" [style.top.px]="notificatonPanelPosition" fxFlex>
    <div fxLayoutAlign="center center" fxFlex="80px">
        <fa-icon [icon]="['fas', 'exclamation-circle' ]" size="3x"
            [styles]="{'stroke-width': '5','stroke': 'red', 'color': 'red'}">
        </fa-icon>
        <p>
    </div>
    <div fxLayout="column" fxLayoutAlign="top left" fxFlex>
        <div class="sliding-notification-panel-header" fxFlex="70px">
            <p class="notification-panel-header">Alert!</p>
        </div>
        <div fxFlex>
            <p class="sliding-notification-panel-body">
                Just a reminder: your temporary password is only valid for 15 minutes. To
                avoid any login issues later, please take a moment to reset your password
                before ending your current session.
            </p>
            <p>
                For further assistance, please contact your Account Representative or email us at
                support@monex.com.
            </p>
        </div>
    </div>
    <div fxFlexAlign="start" fxFlex=25px>
        <fa-icon (mouseup)="hideNotificationPanel()" [icon]="['far', 'times-circle']" size="lg">
        </fa-icon>
    </div>
</div>
<!-- Session timeout overlay -->
<div id="overlay" *ngIf=showOverlay (click)="onOverlayClick($event)">
    <div fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
        <div class="overlay-dialog-container" fxLayout="column" fxLayoutAlign="center center" fxFlex="225px">
            <div class="overlay-dialog-header" fxLayoutAlign="start center" fxFlex="50px">Session Timeout Warning</div>
            <div class="overlay-dialog-body" fxLayoutAlign="center center" fxFlex>Your sesson will
                timeout in&nbsp;<countdown [config]="{ leftTime: 10, format: 'ss' }"
                    (event)="onOverlayTimeoutEvent($event)"></countdown>&nbsp;seconds!</div>
            <div class="overlay-dialog-footer" fxLayout="column" fxLayoutAlign="end center" fxLayoutGap="3px"
                fxFlex="110px">
                <div (mouseup)="onExtendSession($event)" class="green-button-wrapper logout-button"
                    fxLayoutAlign="center center">
                    <div class="green-button" fxLayoutAlign="center center" fxFlex>Extend My Session</div>
                </div>
                <div (mouseup)="logout()" class="green-button-wrapper logout-button" fxLayoutAlign="center center">
                    <div class="green-button" fxLayoutAlign="center center" fxFlex>Logout Now!</div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Side Drawer implementation. Note width is handled in the TS file. -->
<div #sideMenuContainer class="menu" fxLayout="column" fxLayoutAlign="start stretch" [@showMenu]='isMenuShowing' fxFlex>
    <div class="menu-header" fxLayout="column" fxLayoutAlign="start stretch" fxFlexFill fxFlex="200px">
        <div fxFlexAlign="end" fxFlex="35px">
            <fa-icon style="cursor: pointer;" (click)="toggleSideMenu()" [icon]="['far', 'times-circle']" size="lg">
            </fa-icon>
        </div>
        <div class="menu-header-item-first" fxFlexAlign="center" fxFlex="65px">
            <p>Monex</p>
        </div>
        <div class="menu-header-item-second" fxFlexAlign="center" fxFlex="35px">
            <p>America's Precious</p>
        </div>
        <div class="menu-header-item-second" fxFlexAlign="center" fxFlex>
            <p>Metals&nbsp;Marketplace</p>
        </div>
    </div>
    <!-- Menu body -->
    <div fxLayout="column" fxLayoutGap="15px" fxLayoutAlign="start stretch" fxFlex>
        <div class="menu-item" (click)="openSummaryComponent()" fxLayoutAlign="start center" fxFlex="45px">
            <fa-icon [icon]="['fas', 'file-invoice']" size="lg" tooltipClass="menu-tooltip" placement="right"
                ngbTooltip="Summary" [openDelay]="1000" fxFlex="35px"></fa-icon>
            <div fxFlex>Summary</div>
        </div>
        <div class="menu-item" (click)="openAccountStatusComponent()" fxLayout="row" fxLayoutAlign="start center"
            fxFlex="45px">
            <fa-icon [icon]="['fas', 'file-invoice-dollar']" size="lg" tooltipClass="menu-tooltip" placement="right"
                ngbTooltip="Account Summary" [openDelay]="1000" fxFlex="35px"></fa-icon>
            <div fxFlex>Positions</div>
        </div>
        <div class="menu-item" (click)="openAccountHistoryComponent()" fxLayout="row" fxLayoutAlign="start center"
            fxFlex="45px">
            <fa-icon [icon]="['fas', 'chart-pie']" size="lg" tooltipClass="menu-tooltip" placement="right"
                ngbTooltip="Year To Date Activity and Balances" [openDelay]="1000" fxFlex="35px"></fa-icon>
            <div fxFlex>History</div>
        </div>
        <div class="menu-item" (click)="openEdocumentsComponent()" fxLayout="row" fxLayoutAlign="start center"
            fxFlex="45px">
            <fa-icon [icon]="['fas', 'inbox']" size="lg" tooltipClass="menu-tooltip" placement="right"
                ngbTooltip="eDocuments" [openDelay]="1000" fxFlex="35px"></fa-icon>
            <div fxFlex>eDocuments</div>
        </div>
        <div class="menu-item" *ngIf=false (click)="openEsignComponent()" fxLayout="row" fxLayoutAlign="start center"
            fxFlex="45px">
            <fa-icon [icon]="['fas', 'file-signature']" size="lg" tooltipClass="menu-tooltip" placement="right"
                ngbTooltip="Electronic Signing Documents" [openDelay]="1000" fxFlex="35px"></fa-icon>
            <div fxFlex>eSign</div>
        </div>
        <div class="menu-item" (click)="openDepositoryConfirmationComponent()" fxLayout="row"
            fxLayoutAlign="start center" fxFlex="45px">
            <fa-icon [icon]="['fas', 'check-circle']" size="lg" tooltipClass="menu-tooltip" placement="right"
                ngbTooltip="Custodial Confirmations" [openDelay]="1000" fxFlex="35px"></fa-icon>
            <div fxFlex>Depository</div>
        </div>
        <div class="menu-item" (click)="logout()" fxLayout="row" fxLayoutAlign="start center" fxFlex="45px">
            <fa-icon [icon]="['fas', 'sign-out-alt']" size="lg" tooltipClass="menu-tooltip" placement="right"
                ngbTooltip="Logout" [openDelay]="1000" fxFlex="35px"></fa-icon>
            <div fxFlex>Log&nbsp;Out</div>
        </div>
    </div>
    <!-- Menu footer -->
    <div class="menu-footer" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="150px">
        <div fxLayout="row" fxLayoutAlign="center center" fxFlex="35px">
            <fa-icon [icon]="['fas', 'user-friends']" [styles]="{'margin-right': '10px'}"></fa-icon>
            Follow&nbsp;Monex
        </div>
        <div fxLayoutAlign="center center" fxFlex>
            <div fxLayoutAlign="center center" fxFlex>
                <a href="https://www.facebook.com/monexpreciousmetals/">
                    <fa-icon [icon]="['fab', 'facebook']"
                        [styles]="{'color': 'rgb(255, 255, 255)', 'margin-right': '10px'}" size="2x"></fa-icon>
                </a>
                <a href="https://www.linkedin.com/company/monex-precious-metals-company">
                    <fa-icon [icon]="['fab', 'linkedin']"
                        [styles]="{'color': 'rgb(255, 255, 255)', 'margin-right': '10px'}" size="2x"></fa-icon>
                </a>
                <a href="https://www.youtube.com/user/Monexdotcom">
                    <fa-icon [icon]="['fab', 'youtube']" [styles]="{'color': 'rgb(255, 255, 255)'}" size="2x">
                    </fa-icon>
                </a>
            </div>
        </div>
        <div style="font-size: 12px;" fxFlexAlign="center" fxFlex>{{version}}</div>
    </div>
</div>
<!-- Page header, avatar, popover, action bar, and outlet -->
<div class="page-wrapper" fxLayoutAlign="center center" fxFlex>
    <div fxLayout="column" fxLayoutAlign="center center" fxFlex fxFlexFill>
        <!-- Page Header -->
        <header class="header" fxLayout="row" fxLayoutAlign="center center" fxFlexFill fxFlex="100px">
            <div class="company-container" fxLayoutAlign="start stetch" fxLayoutGap="5px" fxFlex="100%">
                <div class="logo-container" *ngIf="isMenuShowing!=true" fxLayout="row" fxLayoutAlign="start center"
                    flex="25px">
                    <div class="monex-header-logo-blue"></div>
                </div>
            </div>
            <!-- New version available - Sync -->
            <ng-template #newVersionPopoverContent>
                <!-- Sliding panels -->
                <div class=sliding-panel-wrapper fxLayout="column" fxLayoutAlign="start center" fxFlexFill>
                    <!-- Main/background non-sliding panel (Sets the popover's bounds) -->
                    <div class="popover-content" fxLayout="column" fxLayoutAlign="center center" fxFlex>
                        <div class="popover-content-header" fxLayoutAlign="start center" fxLayoutGap="10px"
                            fxFlex="80px" fxFlexFill>
                            <div fxLayoutAlign="center stretch" fxFlex>New Version Available</div>
                        </div>
                        <div class="new-version-popover-content-body" fxFlex>                           
                            <p> Click "Update Now" to refresh your portal and access our newest features instantly.</p>
                        </div>
                        <div class="popover-content-body" fxLayout="column" fxLayoutAlign="start center" fxFill fxFlex>
                            <div fxLayoutAlign="center end" fxFlexFill fxFlex>
                                <div class="button-wrapper" fxLayoutAlign="center center" fxFlex>
                                    <button class="green-button" type="button" (click)="downloadNewVersion()"
                                        fxLayoutAlign="center center" fxLayoutGap="5px" fxFlex>
                                        <div fxLayoutAlign="end center" fxFlex="40%">
                                            <fa-icon [icon]="['fas', 'cloud-download-alt']" size="lg"
                                                tooltipClass="menu-tooltip" placement="right" ngbTooltip="Logout"
                                                [openDelay]="1000">
                                            </fa-icon>
                                        </div>
                                        <div fxLayoutAlign="start center" fxFlex>Update Now</div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="avatar-circle" *ngIf="isNewVersionAvailable==true" #popOver="ngbPopover"
                [ngbPopover]="newVersionPopoverContent" [autoClose]="false" [autoClose]="'outside'"
                placement="bottom-right" container="body">
                <span class="initials">
                    <fa-icon [icon]="['fas', 'sync' ]" size="lg" style="color:white;"></fa-icon>
                </span>
            </div>
            <!-- Utilities Popover -->
            <ng-template #popContent>
                <!-- Sliding panels -->
                <div class=sliding-panel-wrapper fxLayout="column" fxLayoutAlign="start center" fxFlexFill>
                    <!-- Password changed success panel -->
                    <div class='utilities-sliding-panel' [style.left.px]="passwordChangeSuccessPanelPosition"
                        fxFlexFill>
                        <div class="change-password-panel" fxLayout="column" fxLayoutAlign="start center" fxFlexFill>
                            <div class="main-popover-header" (click)="onHideSuccessEmailAddressPanelAction()"
                                fxLayout="row" fxLayoutAlign="start center" fxFlex="45px">
                                <div fxFlex="15px">
                                    <fa-icon [icon]="['fas', 'chevron-left' ]" style="color:white; padding-left: 5px;">
                                    </fa-icon>
                                </div>
                                <div fxLayoutAlign="center center" fxFlex>{{successPanelHeaderText}}</div>
                            </div>
                            <div fxLayout="column" fxLayoutAlign="start center" fxFlex>
                                <div fxLayout="column" fxLayoutAlign="center center" fxFlex>
                                    <div fxLayoutAlign="center center" fxFlex><img
                                            src="/assets/images/success-checkmark.svg" alt="Successful save!"></div>
                                </div>
                            </div>
                            <!-- Button. -->
                            <div class="main-popover-footer" fxLayoutAlign="center center">
                                <div class="button-wrapper" fxLayoutAlign="center end" fxFlex>
                                    <button id="password-changed-success-panel" class="green-button" type="button"
                                        (click)="onHideSuccessEmailAddressPanelAction()" fxLayoutAlign="center center">
                                        OK
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Change password panel -->
                    <div class='utilities-sliding-panel' [style.left.px]="changePasswordPanelPosition" fxFlexFill>
                        <div class="change-password-panel" fxLayout="column" fxLayoutAlign="start center" fxFlexFill>
                            <div class="main-popover-header" (click)="onHideChangeEmailAddressPanelAction()"
                                fxLayout="row" fxLayoutAlign="start center" fxFlex="45px">
                                <div fxFlex="15px">
                                    <fa-icon [icon]="['fas', 'chevron-left' ]" style="color:white; padding-left: 5px;">
                                    </fa-icon>
                                </div>
                                <div fxLayoutAlign="center center" fxFlex>Change Password</div>
                                <div fxFlex="40px" style="padding-left: 10px;">
                                    <fa-layers>
                                        <fa-icon [icon]="['fas', 'circle' ]" style="color:rgb(41,69,96)"
                                            transform="grow-24">
                                        </fa-icon>
                                        <fa-icon [icon]="['fas', 'key']" style="color:white" transform="grow-5">
                                        </fa-icon>
                                    </fa-layers>
                                </div>
                            </div>
                            <div fxLayout="column" fxLayoutAlign="start center" fxFlex>
                                <div fxLayout="column" fxLayoutAlign="center center" fxFlex>
                                    <form id="password-change-form" class="input-form form-panel"
                                        style="padding-top: 10px;" spellcheck="false" fxLayout="column"
                                        fxLayoutAlign="start center" [formGroup]="changePasswordFormGroup" fxFlex>
                                        <mat-form-field class="user-id-field" appearance="outline" fxFlex="50px">
                                            <input id="new-password-field" matInput
                                                [type]="newPasswordFieldHide ? 'password' : 'text'"
                                                formControlName="newPasswordFormControl" placeholder="New Password"
                                                required>
                                            <fa-icon matSuffix (click)="newPasswordFieldHide = !newPasswordFieldHide"
                                                [icon]="newPasswordFieldHide ? ['fas', 'eye' ]: ['fas', 'eye-slash' ]">
                                            </fa-icon>
                                            <mat-error
                                                *ngIf="changePasswordFormHasError('newPasswordFormControl', 'required')">
                                                Password is
                                                required
                                            </mat-error>
                                            <mat-error
                                                *ngIf="changePasswordFormHasError('newPasswordFormControl', 'maxlength')">
                                                You have
                                                more
                                                than 45
                                                characters
                                            </mat-error>
                                        </mat-form-field>
                                        <div style="height:30px"></div>
                                        <mat-form-field class="user-id-field" appearance="outline" fxFlex="50px">
                                            <input matInput [type]="confirmPasswordFieldHide ? 'password' : 'text'"
                                                formControlName="confirmPasswordFormControl"
                                                placeholder="Confirm Password" required>
                                            <fa-icon matSuffix
                                                (click)="confirmPasswordFieldHide = !confirmPasswordFieldHide"
                                                [icon]="confirmPasswordFieldHide ? ['fas', 'eye' ]: ['fas', 'eye-slash' ]">
                                            </fa-icon>
                                            <mat-error
                                                *ngIf="changePasswordFormHasError('confirmPasswordFormControl', 'required')">
                                                Password is
                                                required
                                            </mat-error>
                                            <mat-error
                                                *ngIf="changePasswordFormHasError('confirmPasswordFormControl', 'maxlength')">
                                                You have
                                                more
                                                than 35
                                                characters
                                            </mat-error>
                                        </mat-form-field>
                                    </form>
                                </div>
                            </div>
                            <!-- Note the button is outside the form container so the onClick handler is required. -->
                            <div class="main-popover-footer" fxLayoutAlign="center center">
                                <div class="button-wrapper" fxLayoutAlign="center end" fxFlex>
                                    <button class="green-button" form="password-change-form" type="submit"
                                        [disabled]="changePasswordFormGroup.invalid" (click)="saveNewPassword()"
                                        fxLayoutAlign="center center">
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Change User ID panel -->
                    <div class='utilities-sliding-panel' [style.left.px]="changeUserIdPanelPosition" fxFlexFill>
                        <div class="change-password-panel" fxLayout="column" fxLayoutAlign="start center" fxFlexFill>
                            <div class="main-popover-header" (click)="onHideChangeUserIdPanelAction()" fxLayout="row"
                                fxLayoutAlign="start center" fxFlex="45px">
                                <div fxFlex="15px">
                                    <fa-icon [icon]="['fas', 'chevron-left' ]" style="color:white; padding-left: 5px;">
                                    </fa-icon>
                                </div>
                                <div fxLayoutAlign="center center" fxFlex>Change User ID</div>
                                <div fxFlex="40px" style="padding-left: 10px;">
                                    <fa-layers>
                                        <fa-icon [icon]="['fas', 'circle' ]" style="color:rgb(41,69,96)"
                                            transform="grow-24">
                                        </fa-icon>
                                        <fa-icon [icon]="['fas', 'id-card']" style="color:rgb(255, 255, 255)"
                                            transform="grow-4">
                                        </fa-icon>
                                    </fa-layers>
                                </div>
                            </div>
                            <div fxLayout="column" fxLayoutAlign="start center" fxFlex>
                                <div fxLayout="column" fxLayoutAlign="center center" fxFlex>
                                    <form id="user-id-change-form" class="input-form form-panel"
                                        style="padding-top: 10px;" spellcheck="false" fxLayout="column"
                                        fxLayoutAlign="start center" [formGroup]="changeUserIdFormGroup" fxFlex>
                                        <mat-form-field class="user-id-field" appearance="outline" fxFlex="50px">
                                            <input id="new-user-id-field" matInput
                                                formControlName="newUserIdFormControl" placeholder="New User ID"
                                                required>
                                            <mat-error
                                                *ngIf="changeUserIdFormHasError('newUserIdFormControl', 'required')">
                                                User ID required.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="changeUserIdFormHasError('newUserIdFormControl', 'maxlength')">
                                                User ID too long.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="userIdNotUniqueError('newUserIdFormControl', 'userIdNotUnique')">
                                                Existing User ID. Choose another one.
                                            </mat-error>
                                        </mat-form-field>
                                        <div style="height:30px"></div>
                                        <mat-form-field class="user-id-field" appearance="outline" fxFlex="50px">
                                            <input matInput formControlName="confirmUserIdFormControl"
                                                placeholder="Confirm User ID" required>
                                            <mat-error
                                                *ngIf="changeUserIdFormHasError('confirmUserIdFormControl', 'required')">
                                                User ID required.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="changeUserIdFormHasError('confirmUserIdFormControl', 'maxlength')">
                                                User ID too long.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="userIdNotUniqueError('confirmUserIdFormControl', 'userIdNotUnique')">
                                                Existing User ID. Choose another one.
                                            </mat-error>
                                        </mat-form-field>
                                    </form>
                                </div>
                            </div>
                            <!-- Note the button is outside the form container so the onClick handler is required. -->
                            <div class="main-popover-footer" fxLayoutAlign="center center">
                                <div class="button-wrapper" fxLayoutAlign="center end" fxFlex>
                                    <button class="green-button" form="user-id-change-form" type="submit"
                                        [disabled]="changeUserIdFormGroup.invalid" (click)="saveNewUserId()"
                                        fxLayoutAlign="center center">
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Contact Us panel -->
                    <div class='utilities-sliding-panel' [style.left.px]="contactUsPanelPosition" fxFlexFill>
                        <div class="change-password-panel" fxLayout="column" fxLayoutAlign="start center" fxFlexFill>
                            <div class="main-popover-header" fxLayout="row" (click)="onHideContactUsPanelAction()"
                                fxLayoutAlign="start center" fxFlex="45px">
                                <div fxFlex="15px">
                                    <fa-icon [icon]="['fas', 'chevron-left' ]" style="color:white; padding-left: 5px;">
                                    </fa-icon>
                                </div>
                                <div fxLayoutAlign="center center" fxFlex>Contact Us</div>
                                <div fxFlex="40px" style="padding-left: 10px;">
                                    <fa-layers>
                                        <fa-icon [icon]="['fas', 'circle' ]" style="color:rgb(41,69,96)"
                                            transform="grow-24">
                                        </fa-icon>
                                        <fa-icon [icon]="['fas', 'headset']" style="color:white" transform="grow-5">
                                        </fa-icon>
                                    </fa-layers>
                                </div>
                            </div>
                            <div fxLayout="column" fxLayoutAlign="start center" fxFlex>
                                <div fxLayout="column" fxLayoutAlign="center center" fxFlex>
                                    <div class="contact-us-header" fxLayout="column" fxLayoutAlign="center center"
                                        fxLayoutGap="0px" fxFlex="70px">
                                        <div fxFlexAlign="center" fxFlex>Call Us: 949-752-1400</div>
                                        <div fxFlexAlign="center" fxFlex>or</div>
                                        <div fxFlexAlign="center" fxFlex>We Can Call You</div>
                                    </div>
                                    <!-- Form Start -->
                                    <form id="contact-us-form" class="input-form form-panel" style="padding-top: 10px;"
                                        spellcheck="false" fxLayout="column" fxLayoutAlign="start center"
                                        [formGroup]="contactUsFormGroup" fxFlex>
                                        <mat-form-field class="user-id-field" appearance="outline" fxFlex="50px">
                                            <input id="phone-name-id-field" matInput formControlName="nameFormControl"
                                                placeholder="Name" required>
                                            <mat-error *ngIf="contactUsFormHasError('nameFormControl', 'required')">
                                                Name is required.
                                            </mat-error>
                                            <mat-error *ngIf="contactUsFormHasError('nameFormControl', 'maxlength')">
                                                Name is too long.
                                            </mat-error>
                                        </mat-form-field>
                                        <div style="height:30px"></div>
                                        <mat-form-field class="phone-number-id-field" appearance="outline"
                                            fxFlex="50px">
                                            <input input matInput formControlName="phoneNumberFormControl"
                                                (input)="validatePhoneNo($event.target)" placeholder="(___) ___-____">
                                            <mat-error *ngIf="!isValidFlg">
                                                Invalid phone number.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="contactUsFormHasError('phoneNumberFormControl', 'maxlength')">
                                                User ID too long.
                                            </mat-error>
                                        </mat-form-field>
                                    </form>
                                </div>
                            </div>
                            <!-- Note the button is outside the form container so the onClick handler is required. -->
                            <div class="main-popover-footer" fxLayoutAlign="center center">
                                <div class="button-wrapper" fxLayoutAlign="center end" fxFlex>
                                    <button class="green-button" form="contact-us-form" type="submit"
                                        [disabled]="contactUsFormGroup.invalid" (click)="sendContactUsInformation()"
                                        fxLayoutAlign="center center">
                                        Request Callback
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Settings panel -->
                    <div class='utilities-sliding-panel' [style.left.px]="settingsPanelPosition" fxFlexFill>
                        <div class="change-password-panel" fxLayout="column" fxLayoutAlign="start stretch" fxFlexFill>
                            <!-- Header -->
                            <div class="main-popover-header" fxLayout="row" (click)="onHideSettingsPanelAction()"
                                fxLayoutAlign="start center" fxFlex="45px">
                                <div fxFlex="15px">
                                    <fa-icon [icon]="['fas', 'chevron-left' ]" style="color:white; padding-left: 5px;">
                                    </fa-icon>
                                </div>
                                <div fxLayoutAlign="center center" fxFlex>Settings</div>
                                <div fxFlex="40px" style="padding-left: 10px;">
                                    <fa-layers>
                                        <fa-icon [icon]="['fas', 'circle' ]" style="color:rgb(41,69,96)"
                                            transform="grow-24">
                                        </fa-icon>
                                        <fa-icon [icon]="['fas', 'user-cog']" style="color:white" transform="grow-5">
                                        </fa-icon>
                                    </fa-layers>
                                </div>
                            </div>
                            <!-- Body -->
                            <div fxLayout="column" fxLayoutAlign="center stetch" fxFlex>
                                <!-- Form Start -->
                                <form id="settings-form" class="input-form form-panel settings-form-panel"
                                    fxLayout="column" fxLayoutAlign="start start" [formGroup]="settingsFormGroup"
                                    fxFlex>
                                    <mat-slide-toggle>Paperless Statements</mat-slide-toggle>
                                </form>
                            </div>
                            <!-- Note the button is outside the form container so the onClick handler is required. -->
                            <div class="main-popover-footer" fxLayoutAlign="center center">
                                <div class="button-wrapper" fxLayoutAlign="center end" fxFlex>
                                    <button class="green-button" form="settings-form" type="submit"
                                        [disabled]="settingsFormGroup.invalid" (click)="sendContactUsInformation()"
                                        fxLayoutAlign="center center">
                                        OK
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Failed Panel -->
                    <div class='utilities-sliding-panel' [style.left.px]="failedActionPanelPosition" fxFlexFill>
                        <div class="failed-action-panel" fxLayout="column" fxLayoutAlign="start center" fxFlexFill>
                            <div class="main-popover-header" (click)="onHideFailedPanelAction()" fxLayout="row"
                                fxLayoutAlign="start center" fxFlex="45px">
                                <div fxFlex="15px">
                                    <fa-icon [icon]="['fas', 'chevron-left' ]" style="color:white; padding-left: 5px;">
                                    </fa-icon>
                                </div>
                                <div fxLayoutAlign="center center" fxFlex>Change User ID</div>
                            </div>
                            <div class="failed-action-panel-body" fxLayout="column" fxLayoutAlign="start center" fxFlex>
                                Oops! We were unable to make this change.
                                Please call your Account Representative for further assistance.
                            </div>
                            <!-- Note the button is outside the form container so the onClick handler is required. -->
                            <div class="main-popover-footer" fxLayoutAlign="center center">
                                <div class="button-wrapper" fxLayoutAlign="center end" fxFlex>
                                    <button id="failed-panel-button" class="green-button"
                                        (click)="onHideFailedPanelAction()" fxLayoutAlign="center center">
                                        OK
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Main/background non-sliding panel (Sets the popover's bounds) -->
                    <div class="popover-content" fxLayout="column" fxLayoutAlign="center center" fxFlex>
                        <div class="popover-content-header" fxLayoutAlign="start center" fxLayoutGap="10px"
                            fxFlex="80px" fxFlexFill>
                            <div fxFlex="35px">
                                <fa-icon [icon]="['fas', 'user-cog' ]" size="lg" style="color:white;"></fa-icon>
                            </div>
                            <div fxFlex>Support & Settings</div>
                        </div>
                        <div class="popover-content-body" fxLayout="column" fxLayoutAlign="start center" fxFill fxFlex>
                            <div class="popover-content-body-tile" fxLayout="row" fxLayoutAlign="start center"
                                *ngIf="false" fxFill fxFlex="50px">
                                <div fxFlex="40px" style="padding-left: 10px;">
                                    <fa-layers>
                                        <fa-icon [icon]="['fas', 'circle' ]" style="color:black" transform="grow-24">
                                        </fa-icon>
                                        <fa-icon [icon]="['fas', 'tools']" style="color:white" transform="grow-5">
                                        </fa-icon>
                                    </fa-layers>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="start center">
                                    <div fxFlexAlign="start" fxFlex>Address</div>
                                    <div class="popover-content-body-tile-subtitle" fxFlex>Change address information.
                                    </div>
                                </div>
                            </div>
                            <div class="popover-content-body-tile" (click)="onShowChangeEmailAddressPanelAction()"
                                fxLayout="row" fxLayoutAlign="start center" fxFill fxFlex="50px">
                                <div fxFlex="40px" style="padding-left: 10px;">
                                    <fa-layers>
                                        <fa-icon [icon]="['fas', 'circle' ]" style="color:rgb(41,69,96)"
                                            transform="grow-24">
                                        </fa-icon>
                                        <fa-icon [icon]="['fas', 'key']" style="color:white" transform="grow-5">
                                        </fa-icon>
                                    </fa-layers>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="start center">
                                    <div class="popover-content-body-tile-title" fxFlexAlign="start" fxFlex>Password
                                    </div>
                                    <div class="popover-content-body-tile-subtitle" fxFlex>Change Password.
                                    </div>
                                </div>
                            </div>
                            <div class="popover-content-body-tile" (click)="onShowChangeUserIdPanelAction()"
                                fxLayout="row" fxLayoutAlign="start center" fxFill fxFlex="50px">
                                <div fxFlex="40px" style="padding-left: 10px;">
                                    <fa-layers>
                                        <fa-icon [icon]="['fas', 'circle' ]" style="color:rgb(41,69,96)"
                                            transform="grow-24">
                                        </fa-icon>
                                        <fa-icon [icon]="['fas', 'id-card']" style="color:rgb(255, 255, 255)"
                                            transform="grow-4">
                                        </fa-icon>
                                    </fa-layers>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="start center">
                                    <div class="popover-content-body-tile-title" fxFlexAlign="start" fxFlex>User ID
                                    </div>
                                    <div class="popover-content-body-tile-subtitle" fxFlex>Change User ID.
                                    </div>
                                </div>
                            </div>
                            <div class="popover-content-body-tile" (click)="onShowSettingsPanelAction()" fxLayout="row"
                                fxLayoutAlign="start center" *ngIf="false" fxFill fxFlex="50px">
                                <div fxFlex="40px" style="padding-left: 10px;">
                                    <fa-layers>
                                        <fa-icon [icon]="['fas', 'circle' ]" style="color:rgb(41,69,96)"
                                            transform="grow-24">
                                        </fa-icon>
                                        <fa-icon [icon]="['fas', 'user-cog']" style="color:white" transform="grow-5">
                                        </fa-icon>
                                    </fa-layers>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="start center">
                                    <div class="popover-content-body-tile-title" fxFlexAlign="start" fxFlex>Settings
                                    </div>
                                    <div class="popover-content-body-tile-subtitle" fxFlex>Paperless, alerts, etc.</div>
                                </div>
                            </div>
                            <div class="popover-content-body-tile" fxLayout="row" fxLayoutAlign="start center"
                                *ngIf="false" fxFill fxFlex="50px">
                                <div fxFlex="40px" style="padding-left: 10px;">
                                    <fa-layers>
                                        <fa-icon [icon]="['fas', 'circle' ]" style="color:black" transform="grow-24">
                                        </fa-icon>
                                        <fa-icon [icon]="['far', 'bell']" style="color:white" transform="grow-5">
                                        </fa-icon>
                                    </fa-layers>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="start center">
                                    <div fxFlexAlign="start" fxFlex>Notifications</div>
                                    <div class="popover-content-body-tile-subtitle" fxFlex>Sign up for notifications.
                                    </div>
                                </div>
                            </div>
                            <div class="popover-content-body-tile" (click)="onShowContactUsPanelAction()" fxLayout="row"
                                fxLayoutAlign="start center" *ngIf="true" fxFill fxFlex="50px">
                                <div fxFlex="40px" style="padding-left: 10px;">
                                    <fa-layers>
                                        <fa-icon [icon]="['fas', 'circle' ]" style="color:rgb(41,69,96)"
                                            transform="grow-24">
                                        </fa-icon>
                                        <fa-icon [icon]="['fas', 'headset']" style="color:white" transform="grow-5">
                                        </fa-icon>
                                    </fa-layers>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="start center">
                                    <div class="popover-content-body-tile-title" fxFlexAlign="start" fxFlex>Contact Us
                                    </div>
                                    <div class="popover-content-body-tile-subtitle" fxFlex>Available options.
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="popover-content-body-tile" (click)="openProfileComponent()" fxLayout="row"
                                fxLayoutAlign="start center" *ngIf="true" fxFill fxFlex="50px">
                                <div fxFlex="40px" style="padding-left: 10px;">
                                    <fa-layers>
                                        <fa-icon [icon]="['fas', 'circle' ]" style="color:rgb(41,69,96)"
                                            transform="grow-24">
                                        </fa-icon>
                                        <fa-icon [icon]="['fas', 'id-badge']" style="color:white" transform="grow-5">
                                        </fa-icon>
                                    </fa-layers>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="start center">
                                    <div class="popover-content-body-tile-title" fxFlexAlign="start" fxFlex>Profile
                                    </div>
                                    <div class="popover-content-body-tile-subtitle" fxFlex>Customize your profile.
                                    </div>
                                </div>
                            </div> -->
                            <div fxLayoutAlign="center end" fxFlexFill fxFlex>
                                <div class="button-wrapper" fxLayoutAlign="center center" fxFlex>
                                    <button *ngIf="isUtilitiesPanelShowing" id="main-items-panel" class="green-button"
                                        type="button" (click)="logout()" fxLayoutAlign="center center" fxLayoutGap="5px"
                                        fxFlex>
                                        <div fxLayoutAlign="end center" fxFlex="40%">
                                            <fa-icon [icon]="['fas', 'sign-out-alt']" size="lg"
                                                tooltipClass="menu-tooltip" placement="right" ngbTooltip="Logout"
                                                [openDelay]="1000">
                                            </fa-icon>
                                        </div>
                                        <div fxLayoutAlign="start center" fxFlex>Log Out</div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <!-- Avatar circle -->
            <div class="avatar-circle" [ngbPopover]="popContent" (shown)="onPopoverShown()" animation="true"
                [autoClose]="'outside'" placement="bottom-right" container="body" #utilitiesPopOver="ngbPopover">
                <span class="initials">
                    <fa-icon [icon]="['fas', 'user-cog' ]" size="lg" style="color:white;"></fa-icon>
                </span>
            </div>
        </header>
        <!-- Action bar - located below the header -->
        <div class="action-bar" fxLayout="row" fxLayoutAlign="end center" fxFlex="40px">
            <div fxLayoutAlign="start center" fxFlex>
                <div class="hamburger-container" fxLayoutAlign="start center" (mouseup)="toggleSideMenu()" fxFlex>
                    <div class="hamburger" fxLayoutAlign="center center" fxLayoutGap="10px" fxFlex="100px">
                        <fa-icon [icon]="['fas', 'bars']"></fa-icon>
                        <div class="hamburger-text" fxLayoutAlign="start center" fxFlex>Menu</div>
                    </div>
                </div>
                <div class="action-bar" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" fxFlex>
                    <div class="select-container">
                        <mat-form-field appearance="none">
                            <mat-select [(value)]="activeAccount" (selectionChange)="onActiveAccountChange($event)"
                                [compareWith]="objectComparisonFunction" placeholder="No account">
                                <mat-option *ngFor="let item of comboBoxItems" [value]="item">
                                    {{item.accountName | uppercaseFirstLetter}} - {{item.account}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
        <!-- MAIN OUTLET  -->
        <div class="body-container" fxFlexFill fxFlex>
            <div [@routeAnimations]="o && o.activatedRouteData && o.activatedRouteData['animation']" fxFlexFill fxFlex>
                <router-outlet #o="outlet" (activate)="onActivate($event)"></router-outlet>
            </div>
        </div>
    </div>
</div>